// Tema visual del Dashboard B2B (select "Estilo": Claro / Oscuro, por defecto Oscuro).
//
// Las cards y tablas toman sus colores de variables CSS (--dsb-*) definidas en views/dashboard-b2b/index.vue
// según la clase dsb-page--dark/dsb-page--light. ApexCharts dibuja en SVG con colores pasados por opciones, así
// que cada gráfica usa themeMixin (colores en JS) y se remonta cuando cambia el tema.
import { mapState } from 'vuex'

// Se guarda por navegador; sobrevive al logout (ver util/sessionStorageCleanup.js).
export const THEME_STORAGE_KEY = 'dashboard_b2b_theme'

export const THEMES = {
    light: {
        text: '#1d2b4f',
        muted: '#525f7f',
        axis: '#6b7280',
        grid: '#f1f1f1',
        cardBg: '#ffffff'
    },
    dark: {
        text: '#e6edf7',
        muted: '#a0aec0',
        axis: '#a0aec0',
        grid: '#2a3446',
        cardBg: '#161f2e'
    }
}

export function loadTheme() {
    try {
        const saved = localStorage.getItem(THEME_STORAGE_KEY)
        return saved === 'light' || saved === 'dark' ? saved : 'dark'
    } catch (e) {
        return 'dark'
    }
}

export function saveTheme(theme) {
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme)
    } catch (e) {
        // Storage no disponible: el tema solo dura la sesión actual.
    }
}

// Colores del tema actual para las opciones de ApexCharts.
export const themeMixin = {
    computed: {
        ...mapState('dashboard_b2b', ['theme']),
        isDark() {
            return this.theme === 'dark'
        },
        themeColors() {
            return THEMES[this.theme] || THEMES.dark
        },
        // Opciones comunes de ApexCharts: fondo transparente (lo pone la card), textos de ejes/leyenda y
        // tooltip según el tema.
        apexThemeOptions() {
            return {
                background: 'transparent',
                foreColor: this.themeColors.axis
            }
        }
    }
}
